export default __webpack_public_path__ + "static/media/HomeS1.746198d7.png";